import { rankWith, isControl } from '@jsonforms/core';
import type {
  UISchemaElement,
  JsonSchema,
  TesterContext,
} from '@jsonforms/core';

export const urlFileUploadTester = rankWith(
  4,
  (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) => {
    if (!isControl(uischema)) {
      return false;
    }

    const path = uischema.scope;
    const propertySchema =
      context.rootSchema?.properties?.[path.split('/').pop() ?? ''];

    const hasWidget =
      (propertySchema as any)?.['x-widget'] === 'url-file-upload';

    return hasWidget;
  }
);
